/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateGcpIamCredentialForm,
  CreateGcpIamCredentialForm$Outbound,
  CreateGcpIamCredentialForm$outboundSchema,
} from "../components/creategcpiamcredentialform.js";

export type CreateGcpIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateGcpIamCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createGcpIamCredentialForm: CreateGcpIamCredentialForm;
};

/** @internal */
export type CreateGcpIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateGcpIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  CreateGcpIamCredentialSecurity$Outbound,
  CreateGcpIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createGcpIamCredentialSecurityToJSON(
  createGcpIamCredentialSecurity: CreateGcpIamCredentialSecurity,
): string {
  return JSON.stringify(
    CreateGcpIamCredentialSecurity$outboundSchema.parse(
      createGcpIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type CreateGcpIamCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateGcpIamCredentialForm: CreateGcpIamCredentialForm$Outbound;
};

/** @internal */
export const CreateGcpIamCredentialRequest$outboundSchema: z.ZodMiniType<
  CreateGcpIamCredentialRequest$Outbound,
  CreateGcpIamCredentialRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createGcpIamCredentialForm: CreateGcpIamCredentialForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createGcpIamCredentialForm: "CreateGcpIamCredentialForm",
    });
  }),
);

export function createGcpIamCredentialRequestToJSON(
  createGcpIamCredentialRequest: CreateGcpIamCredentialRequest,
): string {
  return JSON.stringify(
    CreateGcpIamCredentialRequest$outboundSchema.parse(
      createGcpIamCredentialRequest,
    ),
  );
}
